<div *ngIf="(pageVm$ | async) as pageVm">

    <app-page-header [vm]="pageVm" title='Chauffeurs Emails' [fullHeader]="true" [canAddNew]="pageVm.canAddNew">
    </app-page-header>

    <div *ngIf="pageVm.contentVm as vm">

        <!-- forms -->
        <div *ngIf="vm.formVm as fvm" class="mt-3">
            <div class="row">
                <div class="col-md-12">
                    <mdb-card narrower="true" cascade="true">
                        <div class="row">
                            <div class="col-md-6">
                                <app-card-header [headingSize]="5" [title]="fvm.title">
                                </app-card-header>
                            </div>
                        </div>
                        <mdb-card-body cascade="true">
                            <ng-container *ngIf="fvm.action === 'delete'">
                                <div class="text-center text-info">
                                    <strong>{{fvm.message}}</strong>
                                </div>
                                <br />
                            </ng-container>
                            <ng-container *ngIf="fvm.action !== 'delete'">
                                <div class="row mt-n4 mb-n4">
                                    <div class="col-md-4">
                                        <div class="mx-2">
                                            <div class="md-form form-group form-sm">
                                                <app-form-input [vm]="fvm.driverCodeVm"
                                                    (textChanged)="chauffeurEmailFormValidate(pageVm, vm, fvm)"></app-form-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="mx-2">
                                            <div class="md-form form-group form-sm">
                                                <app-form-input [vm]="fvm.driverFirstNameVm"></app-form-input>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="mx-2">
                                            <div class="md-form form-group form-sm">
                                                <app-form-input [vm]="fvm.driverLastNameVm"></app-form-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-n4 mb-n4">
                                    <div class="col-md-12">
                                        <div class="mx-2">
                                            <div class="md-form form-group form-sm">
                                                <app-form-input [vm]="fvm.emailInputVm"
                                                    (textChanged)="chauffeurEmailFormValidate(pageVm, vm, fvm)"></app-form-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </mdb-card-body>

                    </mdb-card>
                    <app-form-ok-cancel *ngIf="fvm.okCancelVm" [vm]="fvm.okCancelVm" [isInvalid]="!fvm.isValid"
                        (cancelClicked)="formEnd(pageVm)" (okClicked)="chauffeurEmailFormOk(pageVm, vm, fvm)">
                    </app-form-ok-cancel>
                </div>
            </div>
        </div>

        <!-- main content -->
        <div *ngIf="!vm.formVm">
            <div class="offset-md-1 col-md-10 mt-3">
                <div class="row mt-0">
                    <!-- left side -->
                    <div class="col-md-4 mb-0">
                        <!-- Search form -->
                        <div class="form-inline md-form form-sm my-0">
                            <mdb-icon fas icon="search" aria-hidden="true"></mdb-icon>
                            <input class="form-control form-control-sm ml-5 w-75" type="search" [ngModel]="searchData"
                                (ngModelChange)="doDataSearch(vm, $event)" placeholder="Search text">
                        </div>
                    </div>
                    <!-- right side -->
                    <div class="col-md-8 mr-0">
                    </div>
                </div>
                <div class="mt-3">
                    <app-data-table-card [vm]="vm.chauffeurEmailVm" [showHeader]="false" [keyColumn]="0"
                        (rowActionClick)="rowActionInvoke($event, vm, pageVm)">
                    </app-data-table-card>
                </div>
            </div>
        </div>

    </div>
</div>